module.exports = __webpack_public_path__ + "img/11d@2x.7142c78b.svg";